(function () {
    'use strict';

    angular
        .module('app.score-detail')
        .component('sc3ScoreDetailEditHistory', {
            templateUrl: 'app/score-detail/score-detail-edit-history/score-detail-edit-history.component.html',
            controller: ScoreDetailEditHistoryComponent,
            bindings: { data: '<' }
        });

    ScoreDetailEditHistoryComponent.$inject = ['$element'];
    function ScoreDetailEditHistoryComponent($element) {
        var ctrl = this;
        ctrl.scoreEditHistory = [];
        ctrl.$onInit = init;

        function init() {
            $element.addClass('panel panel-default mat-elevation-z6');
            ctrl.scoreEditHistory = ctrl.data.scoreEditHistory;
        }
    }
})();